var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{attrs:{"flat":""}},_vm._l((_vm.orders),function(order){return _c('order',{key:order.orderId,attrs:{"order":order}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }